import React from 'react';
import {useSelector} from 'react-redux';
import DetailListItem from './components/DetailListItem';
import {TabHeading, Wrapper} from 'Components';
import {customerDetails} from './customerDetails';

const TabProfile = () => {
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const currentMemberDetails = selectedMember.currentMemberDetails;

  const extractedMember = {
    email: currentMemberDetails?.primaryEmail || currentMemberDetails?.clientEmail,
    address: `${currentMemberDetails?.addressLine1 || 'Address not available'}, ${
      currentMemberDetails?.city || 'City not available'
    }, ${currentMemberDetails?.country || 'Country not available'}`,
    postalCode: currentMemberDetails?.postalCode,
  };

  return (
    <Wrapper>
      <TabHeading data={customerDetails} />
      {/* customer_detail from CS is array of objects with key value pairs, each key has to be the same as the key from api result value that we want to display, since that's not possible we have extratedMember that has same keys as array*/}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          columnGap: 32,
          rowGap: 20,
          marginTop: 24,
        }}>
        {customerDetails?.fields?.map((item) => (
          <DetailListItem
            key={item.key}
            label={item.value}
            value={currentMemberDetails[item.key] || extractedMember[item.key]}
          />
        ))}
      </div>
    </Wrapper>
  );
};

export default TabProfile;
